import { render } from "./Billing_and_Insurance.vue?vue&type=template&id=09245cde"
import script from "./Billing_and_Insurance.vue?vue&type=script&lang=js"
export * from "./Billing_and_Insurance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__